import { observable } from 'mobx';
import { Curve } from './Curve';

class Exponential extends Curve {
  @observable a = null;
  @observable b = null;
  @observable c = null;

  static fromJs = (props) => {
    const { a, b, c } = props;
    return new Exponential(a, b, c)
  };

  constructor(a, b, c) {
    super();
    this.a = a;
    this.b = b;
    this.c = c;
  }

  y = (x) => {
    return this.a + this.b * Math.exp(this.c * x);
  };

  toJs = () => {
    return {
      type: 'Exponential',
      a: this.a,
      b: this.b,
      c: this.c,
    };
  };
}

export { Exponential };
